import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, setAnalyticsCollectionEnabled, setConsent } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyBQHns-9fOmUmDsU3VusMsF_e8jsOffmFE",
    authDomain: "cistidoma.firebaseapp.com",
    projectId: "cistidoma",
    storageBucket: "cistidoma.firebasestorage.app",
    messagingSenderId: "315362066346",
    appId: "1:315362066346:web:490b1bbb44bc702572f5d3",
    measurementId: "G-G3RJW9RNP0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
setAnalyticsCollectionEnabled(analytics, true);

const COOLDOWN_MS = 5000;
export const logAnalytics = (eventName = 'contact_click') => {
    const last = Number(localStorage.getItem(eventName) || 0);
    const now = Date.now();

    if (now - last < COOLDOWN_MS) return;

    localStorage.setItem(eventName, now.toString());

    logEvent(analytics, eventName);
}

const fullConsent = {
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    analytics_storage: "granted",
    functionality_storage: "granted",
    personalization_storage: "granted",
    security_storage: "granted",
};

// Consent Required Always
const partialConsent = {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    functionality_storage: "granted",
    personalization_storage: "granted",
    security_storage: "granted",
};

export function setDefaultConsent() {
    setConsent(partialConsent);
    if (window?.gtag) {
        window.gtag("consent", partialConsent);
    }
}

export function setFullConsent() {
    setConsent(fullConsent);
    if (window?.gtag) {
        window.gtag("consent", fullConsent);
    }
}

export function setAnalyticsConsent() {
    setFullConsent();
}

export function phoneClick() {
    if (window?.gtagPhoneClick) {
        window.gtagPhoneClick();
    }
}